export default __webpack_public_path__ + "static/media/logo.dff38c19.png";